import { type Html, html, View } from 'rune-ts';
import klass from './FaqSection.module.scss';
import { font } from '../../../../../shared/typography';

export class FaqSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    return html`
      <section class="${klass.faq}">
        <div class="${klass.title} ${font('48_bold', '28_bold')}">FAQ</div>
        <div class="${klass.faq_item_list}">
          <div class="${klass.faq_item}">
            <div class="${font('24_bold', '16_bold')} ${klass.faq_title}">
              커머스 크리에이터는 무엇인가요?
            </div>
            <div class="${font('20_medium', '14_medium')} ${klass.faq_answer_list}">
              <div class="${klass.faq_answer}">
                다양한 브랜드의 상품을 직접 경험하고, 자신의 개성을 담아 콘텐츠를 제작하는 역할을 합니다.
                콘텐츠를 통해 판매가 발생하면 수익을 창출할 수 있습니다.
              </div>
            </div>
          </div>
          <div class="${klass.faq_item}">
            <div class="${font('24_bold', '16_bold')} ${klass.faq_title}">
              커머스 크리에이터 지원 가능한 조건이 있나요?
            </div>
            <div class="${font('20_medium', '14_medium')} ${klass.faq_answer_list}">
              <div class="${klass.faq_answer}">
                아래 조건 중 하나라도 충족 시, 모두 지원 가능합니다.<br />
                지원 조건에 해당하지 않을 경우 선정에 재한될 수 있는 점 참고 부탁드립니다.
              </div>
              <div class="${klass.faq_answer}">
                <div class="${klass.bold}">1.</div>
                <div class="${klass.bold}">인스타그램 팔로워 10,000명 이상</div>
              </div>
              <div class="${klass.faq_answer}">
                <div class="${klass.bold}">2.</div>
                <div>
                  <div class="${klass.bold}">유튜브 구독자 수 5,000명 이상</div>
                  <div class="${klass.bold}">지난 90일간 공개 동영상 공개 3건 이상</div>
                  <div>그리고 다음 중 한 가지 조건 충족</div>
                  <div class="${klass.requirement_item}">
                    <span>•</span>지난 1년간, 공개 동영상의 유효 시청 시간 3,000시간 이상
                  </div>
                  <div class="${klass.requirement_item}">
                    <span>•</span>지난 90일간, 공개 shorts 동영상의 유효 조회수 300만회 이상
                  </div>
                </div>
              </div>
              <div class="${klass.faq_answer}">
                <div class="${klass.bold}">3.</div>
                <div class="${klass.bold}">틱톡 팔로워 100,000명 이상</div>
              </div>
            </div>
          </div>

          <div class="${klass.faq_item}">
            <div class="${font('24_bold', '16_bold')} ${klass.faq_title}">
              브랜드 협업 진행 시 수수료는 어떻게 되나요?
            </div>
            <div class="${font('20_medium', '14_medium')} ${klass.faq_answer_list}">
              <div class="${klass.faq_answer}">
                브랜드와 제품에 따라 크리에이터의 수수료 및 광고비는 협의를 통해 결정됩니다.<br />
                마플샵 담당 MD가 브랜드와 협상을 전담하여, 크리에이터에게 유리한 조건을 제공할 수 있도록 적극
                지원합니다.
              </div>
            </div>
          </div>

          <div class="${klass.faq_item}">
            <div class="${font('24_bold', '16_bold')} ${klass.faq_title}">
              브랜드 협업 진행 시 비용이 발생하나요?
            </div>
            <div class="${font('20_medium', '14_medium')} ${klass.faq_answer_list}">
              <div class="${klass.faq_answer}">
                마플샵과 함께 브랜드 협업 진행 시 크리에이터가 지불해야 하는 비용은 없습니다.
              </div>
            </div>
          </div>

          <div class="${klass.faq_item}">
            <div class="${font('24_bold', '16_bold')} ${klass.faq_title}">
              협업 콘텐츠를 오픈했는데 판매량이 저조하면 어떡하죠?
            </div>
            <div class="${font('20_medium', '14_medium')} ${klass.faq_answer_list}">
              <div class="${klass.faq_answer}">
                처음 진행하실 때는 판매 수량이 다소 저조할 수 있지만, 브랜드 커머스팀이 콘텐츠 방향성 등
                다양한 부분을 적극 지원해드리니 걱정하지 마시고 도전해 보세요!<br />
                빠르게 시작할수록 수익도 더 빨리 만날 수 있습니다.
              </div>
            </div>
          </div>

          <div class="${klass.faq_item}">
            <div class="${font('24_bold', '16_bold')} ${klass.faq_title}">
              콘텐츠 제작 가이드라인이 있나요?
            </div>
            <div class="${font('20_medium', '14_medium')} ${klass.faq_answer_list}">
              <div class="${klass.faq_answer}">
                콘텐츠 제작에 대한 정해진 틀은 없습니다.<br />
                유튜브 롱폼/쇼츠, 인스타그램 릴스 등 내 채널에 잘 맞는 형태로 자유롭게 콘텐츠를 기획/제작
                해주시면 됩니다. <br />
                단, 브랜디드 광고의 경우 브랜드에서 주요 소구 포인트에 대한 가이드를 제공하여 부담 없이
                제작하실 수 있도록 도와드립니다.
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
